export default __webpack_public_path__ + "static/media/Volkswagen.a1d02e7d.ico";